import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import styles from "../ItemsBlock/ItemsBlock.module.scss";
import Items from "../Items/Items";

const Box = ({ items, handleLinkClick, className }) => {
  return (
    <div className={cn(styles.box, className)}>
      <div className={styles.leftBox}>
        <Items list={items.slice(0, 6)} handleLinkClick={handleLinkClick} />
      </div>
      <div className={styles.rigthBox}>
        <Items list={items.slice(6)} handleLinkClick={handleLinkClick} />
      </div>
    </div>
  );
};

Box.propTypes = {
  handleLinkClick: PropTypes.func.isRequired,
  items: PropTypes.object.isRequired,
  className: PropTypes.string
};

Box.defaultProps = {
  className: ""
};

export default Box;
